import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconMagicWand$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMagicWand extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '3b4882c8a35d669a1aa3cb0a1035bcbefef1d900', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '34ba11272ab7582b8637aa63302acfa8c40cdc1d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7a63f60c41c0702a04c46461a15dbbfb6f681163', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.65 4c-1.667 0-3-1.333-3-3 0 1.667-1.333 3-3 3 1.667 0 3 1.334 3 3 0-1.666 1.333-3 3-3m.05 2c0 1.112.889 2 2 2-1.111 0-2 .89-2 2 0-1.11-.889-2-2-2 1.111 0 2-.888 2-2m-7.195 4.59.707.708L14.51 9l-.707-.707zm2.65-3.357a.5.5 0 0 0-.707 0l-3.004 3.004-.008.008-.01.01-.017.017-7.964 7.965a.5.5 0 0 0 0 .707l1.412 1.413a.5.5 0 0 0 .708 0l7.964-7.965.005-.004.032-.03 3.003-3.003a.5.5 0 0 0 0-.707zM10.5 4c0 .834.667 1.5 1.5 1.5-.833 0-1.5.667-1.5 1.5 0-.833-.667-1.5-1.5-1.5.833 0 1.5-.666 1.5-1.5", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-magic-wand", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-magic-wand"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-magic-wand":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMagicWand$1);
            }
            break;
    } });
}

const CosmosIconMagicWand = CosmosIconMagicWand$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMagicWand, defineCustomElement };
